import React, { useEffect, useState, useRef } from "react";
import AdminHeading from "../AdminPanel/Heading/AdminHeading";
import AdminBreadCrump from "../AdminPanel/Heading/AdminBreadCrump";
// import "../PagesStyles/AdminMasters.css";
import style from "./VendorTouncheNew.module.css";
import Customertable from "Components/support/customervendor/customer";
import {
  a104,
  a107,
  a125,
  a128,
  a131,
  a134,
  a149,
  a163,
  a174,
  a179,
  a180,
  a191,
  a735,
  a95,
  a98,
} from "../../Api/RootApiPath";
import { useSelector } from "react-redux";
import { Icon } from "@iconify/react";
import { RiListUnordered, RiPlayListAddLine } from "react-icons/ri";
import AlertMessage from "../../Other Functions/AlertMessage";
import GetApiService from "../../Api/getapiService.jsx";
import Stonetounch from "../../support/customertounchsupport/stones.jsx";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import Spinner from "Components/CommonComponents/Spinner";
import { useQuery } from "@tanstack/react-query";
import TounchSkuTable from "Components/CommonComponents/TounchSkuTable";
import { fetchAllSku, fetchAllStones } from "services/generalService";
import { VendorTounchSkuColumns, VendorTounchStonesColumns } from "utils/helpers";

export default function VendorTouncheNew() {
  const navigate = useNavigate();
  const [active, setActive] = useState("AddNew");
  const [showError, setShowError] = useState(false);
  const [messageType, setMessageType] = useState("");
  const [messageToShow, setMessageToShow] = useState("");
  const [loading, setLoading] = useState(false);
  const [productsData, setProductsData] = useState([]);
  const [categoriesData, setCategoriesData] = useState([]);
  const [designData, setDesignData] = useState([]);
  const [purityData, setPurityData] = useState([]);
  const [skuData, setSkuData] = useState([]);
  const [templateData, setTemplateData] = useState([]);

  const [filteredData, setFilteredData] = useState([]);
  const [fcat, setFcat] = useState("");
  const [fpro, setFpro] = useState("");

  const [allCategories, setAllCategories] = useState([]);
  const [allVendors, setAllVendors] = useState([]);
  const [newCategory, setNewCategory] = useState({
    VendorId: 0,
    CategoryId: 0,
    ProductId: 0,
    ClientCode: "",
    FinePure: false,
    PurityId: 0,
    FinePercentage: 0,
    WastageWt: "0",
    MakingFixedAmt: "0",
    MakingPerGram: "0",
    MakingFixedWastage: "0",
    MakingPercentage: "0",
    StockKeepingUnit: "",
    CompanyId: 0,
    CounterId: 0,
    BranchId: 0,
    EmployeeId: 0,
    OldEntry: false,
    DiamondSizeWeightRateTemplateId: 0,
    Stones: [],
  });
  const [allCompaniesList, setAllCompaniesList] = useState([]);
  const [allBranchesList, setAllBranchesList] = useState([]);
  const [allDepartmentsList, setAllDepartmentsList] = useState([]);
  const [allRolesList, setAllRolesList] = useState([]);
  const [allSelectedTounche, setAllSelectedTounche] = useState([]);
  const [allSelectedSkus, setAllSelectedSkus] = useState([]);
  const [allSelectedStones, setAllSelectedStones] = useState([]);
  const [allSelected, setAllSelected] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [showSKU, setShowSKU] = useState(true);
  const [isReset, setIsReset] = useState(false);
  const handleSearchChange = (event) => {
    setSearchInput(event.target.value);
  };
  const handleSearchSubmit = () => {
    // You can handle the search logic here
    console.log("Searching for:", searchTerm);
  };

  const allStates = useSelector((state) => state);
  const adminLoggedIn = allStates.reducer1;
  //   let Entryby_Staff_id = parseInt(adminLoggedIn);
  const clientCode = adminLoggedIn.ClientCode;
  const employeeCode = adminLoggedIn.EmployeeCode;
  const CompanyId = adminLoggedIn.CompanyId;
  console.log(adminLoggedIn)
  const BranchId = adminLoggedIn.BranchId;
  const CounterId = adminLoggedIn.CounterId;
  const EmployeeId = adminLoggedIn.EmployeeId;
  const [allStonesList, setAllStonesList] = useState([]);
  const submitButtonRef = useRef(null); // Ref for the Submit button
  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const inputRef4 = useRef(null);
  const inputRef5 = useRef(null);
  const inputRef6 = useRef(null);
  const inputRef7 = useRef(null);
  const inputRef8 = useRef(null);
  const inputRef9 = useRef(null);
  const inputRef10 = useRef(null);
  const inputRef11 = useRef(null);

  const {
    data: allSku,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["vendorTounche/fetchAllSku", clientCode],
    queryFn: fetchAllSku,
    refetchOnWindowFocus: false,
    // cacheTime: 1000 * 60 * 2,
    staleTime: 1000 * 60 * 2,
  });
  const {
    data: allStones,
    isLoading:stoneLoading,
    isError:stoneIsError,
  } = useQuery({
    queryKey: ["vendorTounche/fetchAllStones", clientCode],
    queryFn: fetchAllStones,
    refetchOnWindowFocus: false,
    // cacheTime: 1000 * 60 * 2,
    staleTime: 1000 * 60 * 2,
  });
  console.log(allSku)
  console.log(allStones)

  const handleReset = () => {
    // List of all input and select refs
    const allRefs = [
      inputRef1,
      inputRef2,
      inputRef3,
      inputRef4,
      inputRef5,
      inputRef6,
      inputRef7,
      inputRef8,
      inputRef9,
      inputRef10,
      inputRef11,
    ];

    // Loop through each ref and reset the value
    allRefs.forEach((ref) => {
      if (ref.current) {
        if (ref.current.tagName === "SELECT") {
          ref.current.selectedIndex = 0; // Reset <select> to the first option
        } else {
          ref.current.value = ""; // Clear input field
        }
      }
    });

    // Refocus on the first input after reset
    inputRef1.current?.focus();
  };

  // Focus inputRef1 on component mount
  useEffect(() => {
    inputRef1.current?.focus();
  }, []);

  // Handler function to move focus on Enter key press
  const handleKeyPress = (e, nextInputRef) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent default form submission on Enter
      if (nextInputRef) {
        nextInputRef.current?.focus();
      } else {
        if (submitButtonRef.current) {
          submitButtonRef.current.click(); // Safely trigger click
        } else {
          console.error("Submit button ref is not available");
        }
      }
    }
  };

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  const apiService = new GetApiService(clientCode);

  const loadData = async () => {
    setLoading(true);
    try {
      const apiCalls = [apiService.fetchAllStonesList()];

      const results = await Promise.allSettled(apiCalls);

      results.forEach((result, index) => {
        if (result.status === "fulfilled") {
          // Handle successful response
          switch (index) {
            case 0:
              const fetchedStones = result.value;

              // Convert the fetched stones to the required structure
              const formattedStones = fetchedStones.map((stone) => ({
                CustomerId: 0, // Keep CustomerId as 0
                VendorId: 0, // Keep VendorId as 0 for now, will change later
                
                StoneId: stone.Id,
                StoneName: stone.StoneName,
                StoneWeight: stone.StoneWeight,
                StonePieces: stone.StonePieces,
                StoneRate: stone.StoneRate,
                StoneAmount: stone.StoneAmount,
                StoneLessPercent: stone.StoneLessPercent,
              }));

              console.log("Converted stones:", formattedStones);

              // Set the new category with the converted stones
              setNewCategory((prevCategory) => ({
                ...prevCategory,
                Stones: formattedStones, // Set the converted stones here
              }));

              setAllStonesList(formattedStones);

              break;

            default:
              break;
          }
        } else {
          if (index + 1 > 1) {
            console.error(
              `Error loading data for API ${index + 1}:`,
              result.reason
            );
            // handleError(
            //   `Failed to load data for API ${index + 1}: ${result.reason}`
            // );
          }
        }
      });
    } catch (error) {
      console.error("Error loading data:", error);
      //   handleError("Error loading data. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, [clientCode]);

  const fetchAllCategory = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a174, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    try {
      if (data.length > 0) {
        console.log("check mainitems ", data);
        setAllCategories(data);
      } else {
        setActive("addNew");
        document
          .getElementById("addCategoryListTitle")
          .classList.add("activeCategoryTitle");
        document
          .getElementById("addCategoryListLogo")
          .classList.add("activeCategoryLogo");
        document.getElementById("addCategoryListTitle").click();
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    console.log("category");
    fetchAllCategory();
  }, []);

  useEffect(() => {
    const formData = {
      ClientCode: clientCode,
    };
    fetch(a125, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((res) => res.json())
      .then((data) => setCategoriesData(data));
  }, []);

  useEffect(() => {
    const formData = {
      ClientCode: clientCode,
    };
    fetch(a128, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((x) => x.json())
      .then((y) => {
        setProductsData(y);
      });
  }, []);

  useEffect(() => {
    const formData = {
      ClientCode: clientCode,
    };
    fetch(a134, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log("checking products ", data);
        setPurityData(data);
      });
  }, []);

  useEffect(() => {
    const formData = {
      ClientCode: clientCode,
    };
    fetch(a131, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((res) => res.json())
      .then((data) => setDesignData(data));
  }, []);

  useEffect(() => {
    const formData = {
      ClientCode: clientCode,
    };
    fetch(a163, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log("checking sku data 1", data);
        setSkuData(data);
      });
  }, []);

  useEffect(() => {
    const formData = {
      ClientCode: clientCode,
    };
    fetch(a191, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjIwMzc1MDA4NTksImlzcyI6Ijk4Nzk4ODc2NzU3NjU2NjU0NjU0IiwiYXVkIjoiSW5mb0Bsb3lhbHN0cmluZy5jb20ifQ.nOtc537wlSYm_97ljruCyOcG7wjXOrNUtxZy206OfOQ",
      },
      body: JSON.stringify(formData),
    })
      .then((res) => res.json())
      .then((data) => {
        const processedData = data?.map((item) => ({
          templateID: item?.Id,
          templateName: item?.TemplateName || "default",
        }));
        setTemplateData(processedData);
      });
  }, []);

  const fetchAllCompanies = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a95, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    try {
      if (data.length > 0) {
        setAllCompaniesList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchAllCompanies();
  }, []);

  const fetchAllBranches = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a98, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    try {
      if (data.length > 0) {
        setAllBranchesList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchAllBranches();
  }, []);

  const fetchAllDepartments = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a104, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    try {
      if (data.length > 0) {
        setAllDepartmentsList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchAllDepartments();
  }, []);

  const fetchAllRoles = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a107, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    try {
      if (data.length > 0) {
        setAllRolesList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchAllRoles();
  }, []);

  const fetchAllVendors = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a149, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    try {
      if (data.length > 0) {
        setAllVendors(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchAllVendors();
  }, []);

  const handleNewCategoryChange = (e) => {
    const { name, value, key } = e.target;
    let actualValue = value;
    if (name === "FinePure") {
      actualValue = value === "true";
    }

    if (name == "StockKeepingUnit") {
      let selectedSku = skuData.find((x) => x.StockKeepingUnit == value);
      if (selectedSku) {
        handleAllSelectedTounche(e, selectedSku);
      } else {
        setNewCategory({ ...newCategory, [name]: actualValue });
      }
    }
    setNewCategory({ ...newCategory, [name]: actualValue });
  };

  const addNewCategory = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (allSelectedTounche.length === 0) {
      if (
        !newCategory.VendorId ||
        !newCategory.CategoryId ||
        !newCategory.ProductId ||
        !newCategory.PurityId
      ) {
        alert(
          "Please choose SKU or provide Category, Product, and Purity details."
        );
        setLoading(false);
        return;
      }
    }

    const formData = {
      VendorId: parseInt(newCategory.VendorId),
      CategoryId: parseInt(newCategory.CategoryId),
      ProductId: parseInt(newCategory.ProductId),
      ClientCode: clientCode,
      PurityId: parseInt(newCategory.PurityId),
      WastageWt: `${newCategory.WastageWt}`,
      MakingFixedAmt: `${newCategory.MakingFixedAmt}`,
      MakingPerGram: `${newCategory.MakingPerGram}`,
      MakingFixedWastage: `${newCategory.MakingFixedWastage}`,
      MakingPercentage: `${newCategory.MakingPercentage}`,
      FinePercentage: `${newCategory.FinePercentage}`,
      StockKeepingUnit: newCategory.StockKeepingUnit,
      CompanyId: CompanyId ? CompanyId : 0,
      CounterId: CounterId ? CounterId : 0,
      BranchId: BranchId ? BranchId : 0,
      EmployeeId: EmployeeId ? EmployeeId : 0,
      FinePure: newCategory.FinePure,
      DiamondSizeWeightRateTemplateId: parseInt(
        newCategory.DiamondSizeWeightRateTemplateId
      ),
      SKUList: [],
      Stones: newCategory.Stones.map((stone) => ({
        ...stone,
        VendorId: parseInt(newCategory.VendorId), // Update VendorId for each stone,
      })),
      ...(newCategory.OldEntry ? { Id: newCategory.Id } : {}),
    };
    
    // const newArrayData = newArray.length > 0 ? [...newArray] : [formData];

    let newArrayData;

    // Case 1: if VendorId, CategoryId, ProductId, and PurityId are not 0, empty, or null
    if (
      newCategory.VendorId &&
      newCategory.CategoryId &&
      newCategory.ProductId &&
      newCategory.PurityId
    ) {
      // Use existing logic for this case
      let newArray = allSelectedTounche
        .filter((x) => x.StockKeepingUnit !== newCategory.StockKeepingUnit)
        .map((item) => ({
          ...item,
          FinePure: newCategory.FinePure,
          VendorId: parseInt(newCategory.VendorId),
          CategoryId: parseInt(newCategory.CategoryId),
          ProductId: parseInt(newCategory.ProductId),
          ClientCode: clientCode,
          PurityId: parseInt(newCategory.PurityId),
          WastageWt: `${newCategory.WastageWt}`,
          MakingFixedAmt: `${newCategory.MakingFixedAmt}`,
          MakingPerGram: `${newCategory.MakingPerGram}`,
          MakingFixedWastage: `${newCategory.MakingFixedWastage}`,
          MakingPercentage: `${newCategory.MakingPercentage}`,
          FinePercentage: `${newCategory.FinePercentage}`,
          StockKeepingUnit: item.StockKeepingUnit,
          CompanyId: CompanyId ? CompanyId : 0,
          CounterId: CounterId ? CounterId : 0,
          BranchId: BranchId ? BranchId : 0,
          EmployeeId: EmployeeId ? EmployeeId : 0,
          DiamondSizeWeightRateTemplateId: parseInt(
            newCategory.DiamondSizeWeightRateTemplateId
          ),
          Stones: newCategory.Stones.map((stone) => ({
            ...stone,
            VendorId: parseInt(newCategory.VendorId), // Set VendorId for each stone
          })),
          SKUList: [],
        }));

      newArrayData = newArray.length > 0 ? [...newArray] : [formData];

      // Case 2: if VendorId and allSelectedTounche is not empty
    } else if (newCategory.VendorId && allSelectedTounche.length > 0) {
      // Create SKUList from allSelectedTounche
      const SKUList = 
      // allSelectedTounche
      allSelectedSkus?.map((item) => ({
        // console.log('check items', item)

        VendorId: parseInt(newCategory.VendorId),
        CategoryId: parseInt(item.CategoryId),
        ProductId: parseInt(item.ProductId),
        ClientCode: clientCode,
        PurityId: parseInt(item.PurityId),
        StockKeepingUnit: item.StockKeepingUnit,
        CompanyId: CompanyId ? CompanyId : 0,
        CounterId: CounterId ? CounterId : 0,
        BranchId: BranchId ? BranchId : 0,
        EmployeeId: EmployeeId ? EmployeeId : 0,
        DiamondSizeWeightRateTemplateId: parseInt(
          newCategory.DiamondSizeWeightRateTemplateId
        ),
        FinePercentage: `${newCategory.FinePercentage}`, // Example FinePercentage value
      }));

      newArrayData = [
        {
          ...formData,
          SKUList: SKUList,
        },
      ];
    }
    const SKUList = 
    // allSelectedTounche
    allSelectedSkus?.map((item) => ({
      // console.log('check items', item)

      VendorId: parseInt(newCategory.VendorId),
      CategoryId: parseInt(item.CategoryId),
      ProductId: parseInt(item.ProductId),
      ClientCode: clientCode,
      PurityId: parseInt(item.PurityId),
      StockKeepingUnit: item.StockKeepingUnit,
      CompanyId: CompanyId ? CompanyId : 0,
      CounterId: CounterId ? CounterId : 0,
      BranchId: BranchId ? BranchId : 0,
      EmployeeId: EmployeeId ? EmployeeId : 0,
      DiamondSizeWeightRateTemplateId: parseInt(
        newCategory.DiamondSizeWeightRateTemplateId
      ),
      FinePercentage: `${newCategory.FinePercentage}`, // Example FinePercentage value
    }));

    newArrayData = [
      {
        ...formData,
        SKUList: SKUList,
        Stones: allSelectedStones.map((stone) => ({
          ...stone,
          VendorId: parseInt(newCategory.VendorId), // Update VendorId for each stone,
        }))
      },
    ];

    try {
      const response = await fetch(
        // !newCategory.OldEntry ? a179 : a179, // update a180 add a179
        // a96,
        a735
        ,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(newArrayData),
        }
      );
      const data = await response.json();
      fetchAllCategory();
      setActive("List");
      setAllSelectedTounche([]);
      setAllSelected(false);
      setAllSelectedSkus([])
      setAllSelectedStones([])
      setNewCategory({
        VendorId: 0,
        CategoryId: 0,
        ProductId: 0,
        ClientCode: "",
        PurityId: 0,
        FinePercentage: 0,
        WastageWt: "0",
        MakingFixedAmt: "0",
        MakingPerGram: "0",
        MakingFixedWastage: "0",
        MakingPercentage: "0",
        StockKeepingUnit: "",
        CompanyId: 0,
        CounterId: 0,
        BranchId: 0,
        EmployeeId: 0,
        FinePure: false,
        OldEntry: false,
        DiamondSizeWeightRateTemplateId: 0,
        Stones: [],
      });
      if (data.message) {
        // alert(data.message);
        // setMessageType("error");
        console.log(data.Message);
        setMessageToShow(data.Message);
        // setShowError(true);
        setActive("AddNew");
      } else {
        // setMessageType("success");
        toast.success("Vendor Tounche Added Successfully", {
          duration: 3000,
          position: "top-center",
        });
        // setShowError(true);
      }
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

 

  useEffect(() => {
    setTimeout(() => {
      setShowError(false);
    }, 2000);
  }, [showError]);

  const handleEditData = (data) => {
    console.log(data, "editData");

    // Create a Set to keep track of existing StoneIds in data.Stones
    const existingStoneIds = new Set(data.Stones.map((stone) => stone.StoneId));

    // Create a Set to keep track of StoneIds already added from allStonesList
    const addedStoneIds = new Set();

    // Loop through allStonesList and check for duplicates
    allStonesList.forEach((item) => {
      // Check if the item already exists in data.Stones based on StoneId
      if (
        !existingStoneIds.has(item.StoneId) &&
        !addedStoneIds.has(item.StoneId)
      ) {
        const newStone = {
          CustomerId: 0, // Keep CustomerId as 0
          VendorId: 0, // Keep VendorId as 0 for now
          StoneId: item.StoneId,
          StoneName: item.StoneName,
          StoneWeight: item.StoneWeight,
          StonePieces: item.StonePieces,
          StoneRate: item.StoneRate,
          StoneAmount: item.StoneAmount,
          StoneLessPercent: item.StoneLessPercent,
        };

        // Add the new stone to data.Stones
        data.Stones.push(newStone);

        // Add StoneId to addedStoneIds to prevent future duplicates in this iteration
        addedStoneIds.add(item.StoneId);
      }
    });

    console.log("Updated Stones:", data.Stones); // Log the updated stones

    // Update data with the new Stones array and set the new category
    setNewCategory({
      ...data,
      Stones: data.Stones, // Use the updated stones
      OldEntry: true,
      // Add other properties here as needed
    });

    // console.log('checking stones  ',updatedStones )
    // // Update data with the new Stones array and set the new category
    // setNewCategory({
    //     ...data,
    //     Stones: updatedStones,
    //     OldEntry: true
    // });

    // setNewCategory({...data, OldEntry: true});
    setActive("AddNew");
  };

  const handleAllSelectedTounche = (e, x) => {
    const { value, checked } = e.target;
    if (checked) {
      const newTounche = {
        VendorId: parseInt(newCategory.VendorId),
        CategoryId: parseInt(x.CategoryId),
        ProductId: parseInt(x.ProductId),
        PurityId: parseInt(x.PurityId),
        FinePercentage: newCategory.FinePercentage,
        ClientCode: clientCode,
        FinePure: newCategory.FinePure,
        WastageWt: newCategory.WastageWt,
        MakingFixedAmt: newCategory.MakingFixedAmt,
        MakingPerGram: newCategory.MakingPerGram,
        MakingFixedWastage: newCategory.MakingFixedWastage,
        MakingPercentage: newCategory.MakingPercentage,
        StockKeepingUnit: x.StockKeepingUnit,
        CompanyId: CompanyId ? CompanyId : 0,
        CounterId: CounterId ? CounterId : 0,
        BranchId: BranchId ? BranchId : 0,
        EmployeeId: EmployeeId ? EmployeeId : 0,
        DiamondSizeWeightRateTemplateId: parseInt(
          x.DiamondSizeWeightRateTemplateId
        ),
      };
      setAllSelectedTounche([...allSelectedTounche, newTounche]);
    } else {
      setAllSelectedTounche(
        allSelectedTounche.filter((item) => item.StockKeepingUnit !== value)
      );
    }
  };

 

 
  const handleAmountChange = (index, newRate) => {
    // Update the stone rate at the specified index
    setNewCategory((prevCategory) => {
      const updatedStones = [...prevCategory.Stones];
      updatedStones[index].StoneRate = newRate;
      return {
        ...prevCategory,
        Stones: updatedStones,
      };
    });
  };




  // -----------------------------------------------
  const [allSkuData, setAllSkuData] = useState([]);
  const [allStoneData, setAllStoneData] = useState([]);

  const [resetTable,setResetTable] = useState(false)
  const handleResetField = () => {
    // List of all input and select refs
    
    const allRefs = [
      inputRef1,
      inputRef2,
      inputRef3,
      inputRef4,
      inputRef5,
      inputRef6,
      inputRef7,
      inputRef8,
      inputRef9,
      inputRef10,
      inputRef11,
    ];

    // Loop through each ref and reset the value
    allRefs.forEach((ref) => {
      if (ref.current) {
        if (ref.current.tagName === "SELECT") {
          ref.current.selectedIndex = 0; // Reset <select> to the first option
        } else {
          ref.current.value = ""; // Clear input field
        }
      }
    });
    
    // Refocus on the first input after reset
    inputRef1.current?.focus();
    // setResetTable(true)
    // setAllSkuData([])
  };
  useEffect(() => {
    let filteredItems = [];
    //----------filtering sku items according to conditions---------
    if (
      newCategory.VendorId &&
      !newCategory.CategoryId &&
      !newCategory.ProductId &&
      !newCategory.PurityId
    ) {
      filteredItems = allSku?.filter(
        (item) => item?.VendorId == newCategory.VendorId
      );
    }
    if (
      newCategory.VendorId &&
      newCategory.CategoryId &&
      !newCategory.ProductId &&
      !newCategory.PurityId
    ) {
      filteredItems = allSku?.filter(
        (item) =>
          item?.VendorId == newCategory.VendorId &&
          item?.CategoryId == newCategory.CategoryId
      );
    }
    if (
      newCategory.VendorId &&
      newCategory.CategoryId &&
      newCategory.ProductId &&
      !newCategory.PurityId
    ) {
      filteredItems = allSku?.filter(
        (item) =>
          item?.VendorId == newCategory.VendorId &&
          item?.CategoryId == newCategory.CategoryId &&
          item?.ProductId == newCategory.ProductId
      );
    }
    if (
      newCategory.VendorId &&
      newCategory.CategoryId &&
      newCategory.ProductId &&
      newCategory.PurityId
    ) {
      filteredItems = allSku?.filter(
        (item) =>
          item?.VendorId == newCategory.VendorId &&
          item?.CategoryId == newCategory.CategoryId &&
          item?.ProductId == newCategory.ProductId &&
          item?.PurityId == newCategory.PurityId
      );
    }
    // ------converting stones into proper format-------------
    const formatedStones = allStones?.map((stone)=>({
      CustomerId: 0, // Keep CustomerId as 0
      VendorId: 0, // Keep VendorId as 0 for now, will change later
      Id:stone.Id,
      StoneId: stone.Id,
      StoneName: stone.StoneName,
      StoneWeight: stone.StoneWeight,
      StonePieces: stone.StonePieces,
      StoneRate: stone.StoneRate,
      StoneAmount: stone.StoneAmount,
      StoneLessPercent: stone.StoneLessPercent,
    }))
    setAllSkuData(filteredItems);
    setAllStoneData(formatedStones)
  }, [
    allSku,
    allStones,
    newCategory.VendorId,
    newCategory.CategoryId,
    newCategory.ProductId,
    newCategory.PurityId,
  ]);

 
  return (
    <div>
      <AdminHeading />
      <div style={{ paddingTop: "130px" }}>
        {showError ? (
          <AlertMessage message={messageToShow} type={messageType} />
        ) : null}
        <AdminBreadCrump
          title={"Add Vendor Tounche"}
          companyName={"Loyalstring"}
          module={"Settings"}
          page={"Vendor Tounche"}
        />
      </div>
      <div style={{ padding: "16px" }}>
        <div className={style.adminAddCategoryMainBox}>
          <div className={style.adminAddCategoryInnerBox}>
            <div className={style.adminCategoryAddCategoryMainBox}>
              <form style={{ width: "100%" }} onSubmit={addNewCategory}>
                <div
                  style={{
                    gridTemplateColumns: "repeat(4,2fr)",
                    columnGap: "30px",
                    margin: "0px 0px",
                    padding: "var(--Space-0, 0px) 24px",
                  }}
                  // className="adminCategoryAddCategoryInnerBox"
                >
                  {/* <p
                      style={{ marginTop: "20px", marginBottom: "20px" }}
                     >Add New Vendor Tounche</p> */}
                  <Box sx={{ width: "95%", margin: "0 auto" }}>
                    <div
                      style={{
                        gridTemplateColumns: "repeat(4,1fr)",
                        columnGap: "40px",
                        margin: "15px 0px",
                      }}
                      className="adminCategoryAddCategoryInnerBox"
                    >
                      <label>
                        Select Vendor<sup>*</sup>
                      </label>
                      <select
                        ref={inputRef1}
                        onKeyDown={(e) => handleKeyPress(e, inputRef2)}
                        name="VendorId"
                        value={newCategory.VendorId}
                        onChange={handleNewCategoryChange}
                        required={"required"}
                      >
                        <option value={""}>Select an Option</option>
                        {allVendors.map((x) => {
                          return (
                            <option value={x.Id}>
                              {/* {x.Id} - {x.VendorName} */}
                              {`${x.VendorName} - ${x.Id}`}
                            </option>
                          );
                        })}
                      </select>
                      <label>
                        Select Category<sup>*</sup>
                      </label>
                      <select
                        ref={inputRef2}
                        onKeyDown={(e) => handleKeyPress(e, inputRef3)}
                        name="CategoryId"
                        value={newCategory.CategoryId}
                        onChange={handleNewCategoryChange}
                        // required={"required"}
                      >
                        <option value={""}>Select an Option</option>
                        {categoriesData?.map((x) => {
                          return (
                            <option value={x.Id} key={x.CategoryName}>
                              {x.CategoryName}
                            </option>
                          );
                        })}
                      </select>
                      <label>
                        Select Product<sup>*</sup>
                      </label>
                      <select
                        ref={inputRef3}
                        onKeyDown={(e) => handleKeyPress(e, inputRef4)}
                        // required={"required"}
                        name="ProductId"
                        value={newCategory.ProductId}
                        onChange={handleNewCategoryChange}
                      >
                        <option value={""}>Select an Option</option>
                        {productsData
                          .filter((pro) => {
                            const matchesCategory =
                              newCategory.CategoryId === 0 ||
                              newCategory.CategoryId === "" ||
                              newCategory.CategoryId === null
                                ? true
                                : pro.CategoryId ===
                                  parseInt(newCategory.CategoryId);
                            return matchesCategory;
                          })

                          .map((x) => {
                            return (
                              <option value={x.Id}>{x.ProductName}</option>
                            );
                          })}
                      </select>
                      <label>
                        Select Purity<sup>*</sup>
                      </label>
                      <select
                        ref={inputRef4}
                        onKeyDown={(e) => handleKeyPress(e, inputRef5)}
                        // required={"required"}
                        name="PurityId"
                        value={newCategory.PurityId}
                        onChange={handleNewCategoryChange}
                      >
                        <option value={""}>Select an Option</option>
                        {purityData
                          .filter((pro) => {
                            const matchesCategory =
                              newCategory.CategoryId === 0 ||
                              newCategory.CategoryId === "" ||
                              newCategory.CategoryId === null
                                ? true
                                : pro.CategoryId ===
                                  parseInt(newCategory.CategoryId);
                            return matchesCategory;
                          })

                          .map((x) => {
                            return <option value={x.Id}>{x.PurityName}</option>;
                          })}
                      </select>

                      <label>FinePercentage</label>
                      <input
                        ref={inputRef5}
                        onKeyDown={(e) => handleKeyPress(e, inputRef6)}
                        name="FinePercentage"
                        value={newCategory.FinePercentage}
                        onChange={handleNewCategoryChange}
                        type="text"
                        style={{ border: "1px solid #ddd" }}
                      />

                      <label>Gram/Fine</label>
                      <select
                        ref={inputRef6}
                        onKeyDown={(e) => handleKeyPress(e, inputRef7)}
                        name="FinePure"
                        value={newCategory.FinePure}
                        onChange={handleNewCategoryChange}
                      >
                        <option value={true}>Gram</option>
                        <option value={false}>Fine</option>
                      </select>

                      <label>Wastage</label>
                      <input
                        ref={inputRef7}
                        onKeyDown={(e) => handleKeyPress(e, inputRef8)}
                        name="WastageWt"
                        value={newCategory.WastageWt}
                        onChange={handleNewCategoryChange}
                        type="text"
                        style={{ border: "1px solid #ddd" }}
                      />
                      <label>Making Fixed Amt</label>
                      <input
                        ref={inputRef8}
                        onKeyDown={(e) => handleKeyPress(e, inputRef9)}
                        name="MakingFixedAmt"
                        value={newCategory.MakingFixedAmt}
                        onChange={handleNewCategoryChange}
                        type="text"
                        style={{ border: "1px solid #ddd" }}
                      />
                      <label>Making Per Gram</label>
                      <input
                        ref={inputRef9}
                        onKeyDown={(e) => handleKeyPress(e, inputRef10)}
                        name="MakingPerGram"
                        value={newCategory.MakingPerGram}
                        onChange={handleNewCategoryChange}
                        type="text"
                        style={{ border: "1px solid #ddd" }}
                      />
                      <label>Making Fixed Wastage</label>
                      <input
                        ref={inputRef10}
                        onKeyDown={(e) => handleKeyPress(e, inputRef11)}
                        name="MakingFixedWastage"
                        value={newCategory.MakingFixedWastage}
                        onChange={handleNewCategoryChange}
                        type="text"
                        style={{ border: "1px solid #ddd" }}
                      />
                      <label>Select Template</label>
                      <select
                        name="DiamondSizeWeightRateTemplateId"
                        value={newCategory.DiamondSizeWeightRateTemplateId}
                        onChange={handleNewCategoryChange}
                        ref={inputRef11}
                        onKeyDown={(e) => handleKeyPress(e, null)}
                      >
                        <option value={""}>Select an Option</option>
                        {templateData?.map((x) => {
                          return (
                            <option value={x?.templateID} key={x.templateName}>
                              {x.templateName}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </Box>
                </div>

                <div className={style.skuBtn}>
                  <button
                    type="button" // Add this
                    style={{ marginRight: "10px",
                      border:`${showSKU == true ? "2px solid black":""}` 
                     }}
                    onClick={() => {
                      setShowSKU(true);
                    }}
                  >
                    SKU
                  </button>
                  <button
                    type="button" // Add this
                    style={{border:`${showSKU == false? "2px solid black":""}`}}
                    onClick={() => {
                      setShowSKU(false);
                    }}
                  >
                    Stones
                  </button>
                </div>
                {showSKU ? (
                  <div
                    style={{
                      overflowX: "auto",
                      // borderTop: "1px solid rgba(0,0,0,0.2)",
                      // borderBottom: "1px solid rgba(0,0,0,0.2)",
                      marginTop: "30px",
                      // marginBottom: "20px",
                    }}
                  >
                    {/* <Customertable
                      columns={columns}
                      allCategories={allSkuData}
                      handleEditData={handleEditData}
                      searchInput={searchInput}
                      setSearchInput={setSearchInput}

                    /> */}
                    <TounchSkuTable
                    columns={VendorTounchSkuColumns}
                    data={allSkuData}
                    setAllSelectedSkus={setAllSelectedSkus}
                    isReset={isReset}
                    resetTable={resetTable}
       
                    />
                  </div>
                ) : (
                  // Render alternate UI here
                  <div style={{ marginBottom: "20px" }}>
                    {/* <Stonetounch
                      stones={newCategory.Stones}
                      onAmountChange={handleAmountChange}
                    /> */}
                     <TounchSkuTable
                    columns={VendorTounchStonesColumns}
                    data={allStoneData}
                    setAllSelectedSkus={setAllSelectedStones}
                    isReset={isReset}
                    resetTable={resetTable}
       
                    />
                  </div>
                )}

                <div className={style["btn-container"]}>
                  <button
                    disabled={loading}
                    className={style.buttons}
                    type="submit"
                  >
                    {loading ? (
                      <Spinner />
                    ) : (
                      <Icon icon="ic:baseline-check" width="24" height="24" />
                    )}
                    Submit
                  </button>
                  <button
                    disabled={loading}
                    className={style.buttons}
                    style={{
                      backgroundColor: "#fff",
                      color: "#0077d4",
                      border: "1px solid #0077d4",
                    }}
                    type="button"
                    onClick={handleResetField}
                  >
                    <Icon
                      style={{ color: "#0077d4" }}
                      icon="ix:reset"
                      width="24"
                      height="24"
                    />
                    Reset
                  </button>
                  <button
                    disabled={loading}
                    className={style.buttons}
                    type="button"
                    // onClick={handleList}
                    onClick={() => navigate("/vendor_tounche_new_list")}
                  >
                    <Icon
                      icon="fluent:list-rtl-16-filled"
                      width="24"
                      height="24"
                    />
                    List
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
